<div class="forgot-wrapper">
  <div class="forgot-card">

    <div class="forgot-card-left">
      <div class="forgot-logo-container">
        <img src="assets/Global/Icon_SINCO.png" alt="Grupo SINCO" class="forgot-logo-img" />
      </div>
      <h1>Nueva contraseña</h1>
      <p>Establece una nueva contraseña segura para tu cuenta.</p>

      <div class="forgot-features">
        <div class="feature-item">
          <i class="fa fa-shield"></i>
          <span>Mínimo 6 caracteres</span>
        </div>
        <div class="feature-item">
          <i class="fa fa-lock"></i>
          <span>Contraseña cifrada y segura</span>
        </div>
        <div class="feature-item">
          <i class="fa fa-check-circle"></i>
          <span>Acceso restaurado al instante</span>
        </div>
      </div>
    </div>

    <div class="forgot-card-right">

      <div class="forgot-form-header">
        <h2>Restablecer contraseña</h2>
        <p>Ingresa y confirma tu nueva contraseña.</p>
      </div>

      <ng-container *ngIf="!resetSuccess">

        <div class="reset-error-token" *ngIf="!token && resetError">
          <i class="fa fa-exclamation-triangle"></i>
          <span>{{ resetError }}</span>
        </div>

        <ng-container *ngIf="token">
          <div class="input-group">
            <i class="fa fa-lock input-icon-fa"></i>
            <input
              type="password"
              [(ngModel)]="newPassword"
              name="newPassword"
              placeholder="Nueva contraseña"
              [class.input-error]="resetError"
            />
          </div>

          <div class="input-group">
            <i class="fa fa-lock input-icon-fa"></i>
            <input
              type="password"
              [(ngModel)]="confirmPassword"
              name="confirmPassword"
              placeholder="Confirmar contraseña"
              [class.input-error]="resetError"
            />
          </div>

          <div class="error-message" *ngIf="resetError">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{ resetError }}</span>
          </div>

          <button class="btn-submit" (click)="onSubmit()"
            [disabled]="!newPassword.trim() || !confirmPassword.trim() || isLoading">
            <span>{{ isLoading ? 'Guardando...' : 'Guardar contraseña' }}</span>
            <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-check'"></i>
          </button>
        </ng-container>

      </ng-container>

      <div class="success-message" *ngIf="resetSuccess">
        <div class="success-icon">
          <i class="fa fa-check"></i>
        </div>
        <h3>¡Contraseña restablecida!</h3>
        <p>Tu contraseña fue actualizada correctamente. Serás redirigido al inicio de sesión.</p>
      </div>

      <div class="back-link">
        <a href="#" (click)="goBack()">
          <i class="fa fa-arrow-left"></i>
          Volver al inicio de sesión
        </a>
      </div>

    </div>
  </div>
</div>